import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
} from 'reactstrap'

import api from '../../../../services/api'
import { alertError, alertInfo, alertSuccess } from '../../../../utils/Alert'
import { login } from '../../../../services/auth'

export default function Login() {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    document.body.classList.add('bg-default')
    return () => {
      document.body.classList.remove('bg-default')
    }
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (email === '' || password === '') {
        alertInfo('Por favor preencha todos os campos!')
        return
      }

      const response = await api.post('/admin/login', {
        email,
        password,
      })

      login(response.data.token, response.data.admin, '999')

      history.push('/dashboard')

      setEmail('')
      setPassword('')
    } catch (response) {
      alertError(response.data.error)
    }
  }

  const handleVisiblePassword = (e) => {
    e.preventDefault()

    setVisible(!visible)
  }

  return (
    <>
      <div className="main-content admin-auth bg-default">
        <div className="header bg-gradient-info py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <img src="../../assets/images/logo-white.png" />
                  <h1 className="text-white">Login</h1>
                  <p className="text-lead text-light">
                    Bem vindo a área do administrador!
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100"></div>
        </div>
        {/* Page content */}
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="5" md="8">
              <Card className="bg-secondary shadow border-0">
                <CardBody className="px-lg-5 py-lg-5">
                  <Form role="form">
                    <FormGroup className="mb-3">
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="E-mail"
                          type="email"
                          autoComplete="new-email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value)
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <InputGroup className="input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i
                              className="fa fa-unlock-alt"
                              aria-hidden="true"
                            ></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Senha"
                          type={visible === true ? 'text' : 'password'}
                          autoComplete="new-password"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value)
                          }}
                        />
                        <InputGroupAddon>
                          <InputGroupText>
                            {visible === false ? (
                              <a onClick={(e) => handleVisiblePassword(e)}>
                                <i className="fa fa-eye"></i>
                              </a>
                            ) : (
                              <a onClick={(e) => handleVisiblePassword(e)}>
                                <i className="fa fa-eye-slash"></i>
                              </a>
                            )}
                          </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </FormGroup>

                    <div className="group-button-link">
                      <Button
                        className="my-4"
                        color="primary"
                        type="button"
                        onClick={(e) => handleSubmit(e)}
                      >
                        Entrar
                      </Button>
                      <a
                        className="text-light"
                        onClick={(e) => history.push('/admin/forgot')}
                      >
                        <small>Esqueceu sua senha?</small>
                      </a>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
